export default function ProgressSkeleton() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-70">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md text-center animate-pulse relative">
        <div className="absolute top-2 right-2 h-6 w-6 bg-gray-300 rounded-full" />

        <div className="h-6 w-2/3 mx-auto bg-gray-300 rounded mb-4" />

        <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
          <div className="bg-gray-300 h-4 w-1/2 rounded-full" />
        </div>

        <div className="mt-4 h-4 w-3/4 mx-auto bg-gray-300 rounded" />

        <div className="mt-6 h-10 w-1/2 mx-auto bg-blue-300 rounded" />
      </div>
    </div>
  );
}